import { render, staticRenderFns } from "./Environmental_Hazards.vue?vue&type=template&id=2f9ddfac&"
import script from "./Environmental_Hazards.vue?vue&type=script&lang=js&"
export * from "./Environmental_Hazards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports